import React, { useMemo } from "react";
import CaptionExpand from "./components/CaptionExpand";
import MediaSection from "./components/MediaSection";
import { BaseSocialCardProps } from "./types";

interface GenericCardProps extends BaseSocialCardProps {
  title?: string;
  // platformName?: string; // Removed as per wireframe style and lint error
  platformIcon?: React.ReactNode; // Allow specifying platform icon
}

const GenericCard = ({
  caption,
  mediaUrls = [],
  isTemplateVideo,
  // username = "User", // Remove unused prop
  // profileUrl, // Remove unused prop
  // postedAt, // Remove unused prop
  // title = "Sample Title", // Remove unused prop
}: GenericCardProps) => {
  // const [expanded, setExpanded] = useState(false); // Remove unused state

  // Remove unused logic related to expansion
  // const needsExpansion = useMemo(() => { ... });

  const displayCaption = useMemo(() => {
    // Generic card doesn't have platform limits, just display full caption
    return caption;
  }, [caption]);

  // Remove unused render function
  // const renderCaption = (text: string) => text;

  // Remove unused date calculation
  // const captionDate = useMemo(() => { ... });

  return (
    <div className="w-full max-w-md mx-auto bg-antd-colorBgContainer border border-antd-colorBorderSecondary rounded-lg shadow-md overflow-hidden p-4">
      {/* Restore style block for hashtags, using antd token */}
      <style>{`
        .generic-card-preview .hashtag {
          color: #0095F6; /* Using Instagram's Blue */
          text-decoration: none;
        }
        .generic-card-preview .hashtag:hover {
          text-decoration: underline;
        }
        /* Links (.caption-link) remain default text color */
      `}</style>

      {/* Wireframe Header */}
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-3">
          {/* Wireframe Avatar */}
          <div className="w-10 h-10 bg-antd-colorFill rounded-full"></div>
          <div className="flex flex-col gap-1">
            {/* Wireframe Username */}
            <div className="h-3 w-24 bg-antd-colorFill rounded"></div>
            {/* Wireframe Subtitle (Timestamp/Platform) */}
            <div className="flex items-center gap-1">
              <div className="h-2 w-16 bg-antd-colorFillSecondary rounded"></div>
            </div>
          </div>
        </div>
        {/* Wireframe More Options Icon */}
        <div className="w-5 h-5 bg-antd-colorFill rounded-full"></div>
      </div>

      {/* Caption */}
      {displayCaption && (
        <div className="mb-3">
          <CaptionExpand
            text={displayCaption}
            initialLines={3}
            showMoreText="... more"
            showLessText="...less"
            linkColor="gray"
            className="text-sm"
          />
        </div>
      )}

      <div className="-mx-4 flex mb-3 min-h-[200px] border-t border-b border-antd-colorBorderSecondary">
        <MediaSection mediaUrls={mediaUrls} isTemplateVideo={isTemplateVideo} />
      </div>

      {/* Wireframe Action Buttons */}
      <div className="flex justify-between">
        {/* Left Group */}
        <div className="flex items-center gap-4">
          {/* Wireframe Like Icon */}
          <div className="w-6 h-6 bg-antd-colorFill rounded-full"></div>
          {/* Wireframe Comment Icon */}
          <div className="w-6 h-6 bg-antd-colorFill rounded-full"></div>
          {/* Wireframe Share Icon */}
          <div className="w-6 h-6 bg-antd-colorFill rounded-full"></div>
        </div>
        {/* Right Icon */}
        <div className="w-6 h-6 bg-antd-colorFill rounded-full"></div>
      </div>
    </div>
  );
};

export default GenericCard;
